import { NcwOnboardingSlideThree } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { useOnboardingSlidesTranslations } from '@capsicum/features/nc-onboarding/web';
import { type FC } from 'react';

import * as S from './components.styled';
import { Shell } from './Shell';

export const FourthPoblanoPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell
			cta={
				<S.CTAWrapper>
					<Button
						color="brand"
						testID="onboarding-register-button"
						text={$t('onboarding.buttons.register')}
						onClick={next}
					/>
				</S.CTAWrapper>
			}
			goBack={goBack}
		>
			<S.ImageWrapper>
				<S.Image
					alt="fourthNCW-slide-image"
					data-testid="onboarding-fourth-slide-image"
					src={NcwOnboardingSlideThree}
				/>
			</S.ImageWrapper>

			<S.HeadlineText>{$t('onboarding.ncw.three.title')}</S.HeadlineText>
			<S.Dropline>{$t('onboarding.ncw.three.description')}</S.Dropline>
		</Shell>
	);
};
